<div class="container mt-3 text-center">
  <osre-language-switcher class=""></osre-language-switcher>

  <h3 class="mt-5" translate>Your invitation link has expired , please contact the agent to renew the invitation link.</h3>
  <a [routerLink]="['authentication']" class="" translate>Login page</a>
</div>

